export default "__VITE_PUBLIC_ASSET__fb631d0b__"